export default {"src":"/_next/static/media/cookies.9bc67dc6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};